import styled from '@emotion/styled';
import { __t } from '../../i18n';
import { IconDown, IconUp } from '../../icons';
import { Button, Flex } from '../../styles';
import { SpacingIndex } from '../../theme';

/** Size of the buttons below. ShortsContainer reserves a rail this wide beside the player. */
export const NAV_BUTTON_SIZE: SpacingIndex = 6;

type EpisodeNavProps = {
  prevFileId?: string;
  nextFileId?: string;
  onSelect: (fileId?: string) => void;
};

/** Desktop counterpart of the vertical swipe. */
export default function EpisodeNav({ prevFileId, nextFileId, onSelect }: EpisodeNavProps) {
  if (!prevFileId && !nextFileId) return null;

  return (
    <Flex direction="column">
      <ControlButton
        type="button"
        mb={2}
        disabled={!prevFileId}
        onClick={() => onSelect(prevFileId)}
        aria-label={__t('shorts.previous_episode')}
      >
        <IconUp />
      </ControlButton>
      <ControlButton
        type="button"
        disabled={!nextFileId}
        onClick={() => onSelect(nextFileId)}
        aria-label={__t('shorts.next_episode')}
      >
        <IconDown />
      </ControlButton>
    </Flex>
  );
}

const ControlButton = styled(Button)(({ theme }) => ({
  border: 0,
  padding: 0,
  width: theme.spacing(NAV_BUTTON_SIZE),
  height: theme.spacing(NAV_BUTTON_SIZE),
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.background[600][0],
  color: theme.palette.text[700][0],
  cursor: 'pointer',
  '& svg': {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
  ':disabled': {
    background: theme.rgba(theme.palette.background[600][0], 0.5),
    cursor: 'not-allowed',
  },
}));
